import { LessonContent, Note, NoteAnchor, NoteDTO } from '../model/types';

export const parseNoteDTO = (dto: NoteDTO): Note => {
  return {
    id: dto.id,
    accountId: dto.account_id,
    moduleId: dto.module_id,
    lessonId: dto.lesson_id,
    note: dto.note,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
    anchor: dto.anchor
      ? ({
          sectionId: dto.anchor.section_id,
          offset: dto.anchor.offset,
          length: dto.anchor.length,
        } as NoteAnchor)
      : undefined,
  } as Note;
};

export const getLessonContentById = (
  lessons: LessonContent[],
  id: string,
): LessonContent | null => {
  // eslint-disable-next-line no-restricted-syntax
  for (const lesson of lessons) {
    if (lesson.id === id) {
      return lesson;
    }

    if (lesson.children?.length) {
      const found = getLessonContentById(lesson.children, id);

      if (found) {
        return found;
      }
    }
  }

  return null;
};
